import React, { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  AppShell as MantineAppShell,
  useMantineTheme,
} from "@mantine/core";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AppContext } from "src/api/AppContext";
import { useBrandingContext } from "src/api/context/BrandingContext";
import { UserRole } from "src/generated/graphql";
import Onboarding from "../Onboarding";
import { useNavigate } from "react-router-dom";
// import { bgGR, bgGRDark } from "src/assets";
import { useElementSize, useMediaQuery } from "@mantine/hooks";

interface Props {
  children: React.ReactNode;
}

const AppShell: FC<Props> = ({ children }) => {
  const { currentUser, isDarkMode, setWorkspaceDimensions } =
    useContext(AppContext);
  const [isNavbarOpen, setNavbarOpened] = useState<boolean>(false);
  const toURL = window.location.pathname?.split("/")[1];
  const navigate = useNavigate();
  const { ref, width, height } = useElementSize();
  const theme = useMantineTheme();

  const desktopView = useMediaQuery("(min-width: 550px)");
  const mdBreakpoint = useMediaQuery("(min-width: 62em)");

  useEffect(() => {
    setWorkspaceDimensions && setWorkspaceDimensions({ width, height });
  }, [width, height, setWorkspaceDimensions]);

  useEffect(() => {
    let toUrl = window.localStorage.getItem("toURL");
    if (toUrl && currentUser) {
      window.localStorage.removeItem("toURL");
      navigate(toUrl);
    }
  }, [currentUser]);

  return currentUser?.acceptedTAC ? (
    <MantineAppShell
      fixed
      navbarOffsetBreakpoint={"md"}
      styles={(theme) => ({
        //styles added to main apply to appshell children
        main: {
          backgroundColor: theme.colors.secondary[2],
          color: theme.colors.secondaryTextColor[2],
        },
      })}
      header={
        <Header
          showLocationSelect={true}
          showUserMenu={true}
          isNavbarOpen={isNavbarOpen}
          setNavbarOpened={setNavbarOpened}
          showThemeIcon
        />
      }
      navbar={
        <>
          <Navbar isOpened={isNavbarOpen} setNavbarOpened={setNavbarOpened} />
        </>
      }
      footer={
        <Footer
          isMobile={currentUser?.role === UserRole.Client ? true : false}
          title={`Copyright © ${new Date().getFullYear()} Sindro`}
        />
      }
      sx={{
        ".mantine-AppShell-main": {
          paddingLeft: mdBreakpoint
            ? "calc(var(--mantine-navbar-width, 0px))"
            : 16,
        },
      }}
    >
      <Box
        ref={ref}
        style={{
          overflowY: "auto",
          height:
            "calc((100vh - (var(--mantine-header-height, 0px) + var(--mantine-footer-height, 0px) + 32px )) )",
        }}
      >
        {desktopView
          ? // <ScrollArea.Autosize
            //   maxHeight={
            //     "calc((100vh - (var(--mantine-header-height, 0px) + var(--mantine-footer-height, 0px) + 32px )) )"
            //   }
            //   type="auto"
            // >
            children
          : // </ScrollArea.Autosize>
            children}
      </Box>
    </MantineAppShell>
  ) : (
    <Onboarding />
  );
};

export default AppShell;

interface Props {
  children: React.ReactNode;
}

export const UnsubAppShell: FC<Props> = ({ children }) => {
  const { isFlatPage } = useBrandingContext();
  return (
    <MantineAppShell
      fixed
      navbarOffsetBreakpoint={"md"}
      padding={0}
      styles={(theme) => ({
        //styles added to main apply to appshell children
        main: {
          backgroundColor: theme.colors.secondary[2],
          color: theme.colors.secondaryTextColor[2],
          backgroundSize: 600,
        },
      })}
      header={
        isFlatPage ? (
          <></>
        ) : (
          <Header
            showLocationSelect={false}
            showUserMenu={false}
            isNavbarOpen={false}
            setNavbarOpened={() => {}}
            hideNavMenu
          />
        )
      }
      navbar={<></>}
      footer={
        isFlatPage ? (
          <></>
        ) : (
          <Footer
            isMobile={false}
            title={`Copyright © ${new Date().getFullYear()} Sindro`}
          />
        )
      }
    >
      {children}
    </MantineAppShell>
  );
};
